<template lang="pug">
  #signUpSuccess
    .container-width.p-3
      h5.text-center.font-weight-bold.pb-5.mb-5 申請LINE個人化服務
      .icon
        .icon-area
          .icon-success.mx-auto.text-center
            .success.mb-5
              .action
                .trophy.mx-auto
                  .circle.mb-5
                    img(
                      :src='okImg',
                      alt='success_ok_img'
                    )
                    .light
                    .light.two
                    .light.three
                    .light.four
                    .light2
                    .light2.two
                    .light2.three
                    .light2.four
            h4 顧問綁定成功!
      p.text-center 恭喜您成功開通顧問服務。
      .row.p-3.pt-5.mx-2
        .col-12
          button.btn.btn-block.btn-primary(
            type="button",
            @click="backToLINEHandler()"
          ) 返回官方帳號
</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_ok.png';

export default {
  name: 'saSuccess',
  data() {
    return {
      okImg: okImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style lang="scss" scoped>
#signUpSuccess {
    background: url('~@/assets/images/bg/bg_success.png')no-repeat center center;
    background-size: contain;
    background-position-y: 30%;
}
</style>
